































import Vue from 'vue'
interface PuffLink {
	url: string,
	rel: string,
	text: string
}

interface PuffProps {
	text: string,
	textColor: string,
	bgColor: string,
	bgColorIcone: string,
	hasLink: boolean,
	linkUrl: string,
	linkRel: string,
	icone: string,
	iconePil: string
}

export default Vue.extend<{}, {}, {}, PuffProps>({
	name: 'Puff',
	computed: {
		text() { 
			var text:string = this.$store.getters.text;
			return (text.length === 0 || !text.trim())  ? '' : text;
		},
		textColor(){ return this.$store.getters.textColor},
		bgColor() { return this.$store.getters.bgColor},
		bgColorIcone() { return this.$store.getters.bgColorIcone},
		hasLink(){ return this.$store.getters.hasLink},
		icone(){return this.$store.getters.icone},
		iconePil(){return this.$store.getters.iconePil},
		puffLink(){ 
			try{
				if(!this.$store.getters.hasLink)
					return null;

				var link: PuffLink = {
					url: this.$store.getters.linkUrl,
					rel: this.$store.getters.linkRel,
					text: this.$store.getters.linkAltText
				};
				return link;
			}
			catch(e)
			{
				console.log(e.message);
			}
		}
	}
})
